import React from 'react';
import './styles.scss';

const SpotPoint = ({ onClick = () => {}, isSelected }) => (
  <div className={`SpotPoint ${isSelected ? '--active' : ''}`} onClick={onClick}></div>
);

export default SpotPoint;
